import { Box, List } from "@mui/material";
import PropTypes from "prop-types";
import { NavListRoot } from "./NavList";
import { useState } from "react";

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({
  key,
  navConfig,
  isCollapse = false,
  ...other
}) {

  const [openMenu, setOpenMenu] = useState(null);

  const handleOpenMenu = (menuTitle) => {
    setOpenMenu((prev) => (prev === menuTitle ? null : menuTitle));
  };

  return (
    <Box {...other}>
      {navConfig.map((group, i) => {
        return (
          <List key={i} disablePadding sx={{ px: 2 }}>
            {group.items.map((list) => {
              return (
                <NavListRoot
                  key={list.title}
                  list={list}
                  isCollapse={isCollapse}
                  openMenu={openMenu}
                  handleOpenMenu={handleOpenMenu}
                />
              );
            })}
          </List>
        );
      })}
    </Box>
  );
}
